import { MarketersPageStates } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETER_PAGE_STATUS = 'UPDATE_INTERNAL_MARKETER_PAGE_STATUS';
export type UPDATE_INTERNAL_MARKETER_PAGE_STATUS = typeof UPDATE_INTERNAL_MARKETER_PAGE_STATUS;

export interface UpdateInternalMarketerPageStatus {
    type: UPDATE_INTERNAL_MARKETER_PAGE_STATUS;
    pageStatus: MarketersPageStates;
}

export function updateInternalMarketerPageStatusAction(
    pageStatus: MarketersPageStates
): UpdateInternalMarketerPageStatus {
    return {
        type: UPDATE_INTERNAL_MARKETER_PAGE_STATUS,
        pageStatus
    };
}
